export const KPI_ENGLISH = {
  "datox.kpi.layout": "KPI layout",
  "datox.kpi.standard": "Standard",
  "datox.kpi.compact": "Compact",
  "datox.kpi.prominent": "Prominent",
  "datox.kpi.currencyFormat": "Currency",
  "datox.kpi.currency": "Currency code",
  "datox.kpi.unit": "Unit",
  "datox.kpi.notation": "Notation and scaling",
  "datox.kpi.thousands": "Thousands (K)",
  "datox.kpi.millions": "Millions (M)",
  "datox.kpi.billions": "Billions (B)",
  "datox.kpi.percentScale": "Percentage mode",
  "datox.kpi.points": "Points (0.25 → 0.25%)",
  "datox.kpi.ratio": "Ratio (0.25 → 25%)",
  "datox.kpi.target": "Target",
  "datox.kpi.targetValue": "Target value (source units)",
  "datox.kpi.targetHelp": "Use the same units as the source value, before percentage or K/M/B scaling. For a 50% ratio target, enter 0.5.",
  "datox.kpi.none": "None",
  "datox.kpi.bar": "Bar",
  "datox.kpi.ring": "Ring",
  "datox.kpi.actual": "Actual",
  "datox.kpi.progress": "Target completion",
  "datox.kpi.loading": "Loading KPI…",
  "datox.kpi.error": "Couldn't load the KPI",
  "datox.kpi.missing": "No data",
  "datox.kpi.invalid": "Check KPI display settings and enter a positive target",
  "datox.kpi.calculation": "Calculation mode",
  "datox.kpi.aggregation": "Aggregation",
  "datox.kpi.formula": "Formula",
  "datox.kpi.expression": "KPI formula",
  "datox.kpi.formulaHelp": "Use sum, avg, min, max, count(), safe_divide, round, abs or if_else. Wrap columns with spaces in backticks.",
  "datox.kpi.apply": "Apply formula",
  "datox.kpi.preview": "Result preview",
  "datox.kpi.unavailable": "Unavailable",
  "datox.kpi.explain": "Explain source",
  "datox.kpi.sourceRows": "Applicable rows: {count}",
  "datox.kpi.sourceDataset": "Source dataset: {name}",
  "datox.kpi.sourceColumns": "Referenced columns: {names}",
  "datox.kpi.sourceFilters": "Filters applied: {count}",
  "datox.kpi.sourceSort": "Sorted by: {column}",
  "datox.kpi.sourceLimit": "Row limit: {count}",
  "datox.kpi.sourceSubtitle": "Understand how this KPI is calculated",
  "datox.kpi.sourceResult": "Calculated result",
  "datox.kpi.sourceData": "Source dataset",
  "datox.kpi.sourceSelectedDataset": "Selected dataset",
  "datox.kpi.sourceFields": "Columns used in this calculation",
  "datox.kpi.sourceTechnical": "Show dataset ID",
  "datox.kpi.sourceConstraints": "Filters and limits",
  "datox.kpi.sourceNoConstraints": "All source rows are included. No filters or limits are applied.",
  "datox.kpi.sourceEvidence": "Source rows",
  "datox.kpi.sourceEvidenceHelp": "Showing {shown} of {total} applicable rows. The calculation uses all applicable rows.",
  "datox.kpi.sourceAllColumns": "Show all columns",
  "datox.kpi.sourceRelevantColumns": "Show calculation columns",
  "datox.kpi.sourceNoRows": "No source rows match the current filters and limits.",
  "datox.kpi.sourceClose": "Close",
  "datox.kpi.sourceRetry": "Try again",
  "datox.kpi.expression_required": "Enter a formula expression.",
  "datox.kpi.expression_too_long": "Keep the formula under 1,000 characters.",
  "datox.kpi.too_complex": "Simplify the formula (up to 100 parts and 20 nested levels).",
  "datox.kpi.unknown_column": "Unknown column: {column}. Check the source column names.",
  "datox.kpi.numeric_column_required": "Column {column} must contain numbers.",
  "datox.kpi.unsupported_function": "Unsupported function: {function}. Use a supported KPI function.",
  "datox.kpi.aggregate_arguments": "{function}() needs one column name.",
  "datox.kpi.function_arguments": "Check the arguments to {function}().",
  "datox.kpi.aggregate_required": "Reference columns inside sum(), avg(), min() or max().",
  "datox.kpi.round_digits": "round() needs a whole-number precision from 0 to 6.",
  "datox.kpi.invalid_expression": "Check the formula syntax and backticks.",
  "datox.kpi.invalid_calculation": "Use a version 1 KPI formula.",
  "datox.kpi.widget_id_required": "This KPI needs a widget ID before you can save a formula.",
  "datox.kpi.duplicate_widget_id": "Widget ID {widget} is used more than once. Give each widget a unique ID.",
  "datox.kpi.formula_widget_type": "Formulas are supported only on KPI widgets.",
  "datox.kpi.ambiguous_column": "Column alias {column} is ambiguous. Use the exact column name in backticks.",
  "datox.kpi.exportPreparing": "Preparing PDF: waiting for KPI results…",
  "datox.kpi.exportTimeout": "KPI results took too long to load. Check the connection and try exporting again.",
  "datox.kpi.exportFailed": "Couldn't export the dashboard. Resolve any KPI errors and try again.",
  "datox.kpi.unsupported_expression": "This expression or operator is not supported in KPI formulas.",
} as const

export function dashboardKpiLabels(t: (key: keyof typeof KPI_ENGLISH) => string) {
  return {
    layout: t("datox.kpi.layout"), standard: t("datox.kpi.standard"), compact: t("datox.kpi.compact"), prominent: t("datox.kpi.prominent"),
    currencyFormat: t("datox.kpi.currencyFormat"), currency: t("datox.kpi.currency"), unit: t("datox.kpi.unit"), notation: t("datox.kpi.notation"),
    thousands: t("datox.kpi.thousands"), millions: t("datox.kpi.millions"), billions: t("datox.kpi.billions"),
    percentScale: t("datox.kpi.percentScale"), points: t("datox.kpi.points"), ratio: t("datox.kpi.ratio"),
    target: t("datox.kpi.target"), targetValue: t("datox.kpi.targetValue"), targetHelp: t("datox.kpi.targetHelp"),
    none: t("datox.kpi.none"), bar: t("datox.kpi.bar"), ring: t("datox.kpi.ring"), actual: t("datox.kpi.actual"), progress: t("datox.kpi.progress"),
    loading: t("datox.kpi.loading"), error: t("datox.kpi.error"), missing: t("datox.kpi.missing"), invalid: t("datox.kpi.invalid"),
    calculation: t("datox.kpi.calculation"), aggregation: t("datox.kpi.aggregation"), formula: t("datox.kpi.formula"),
    expression: t("datox.kpi.expression"), formulaHelp: t("datox.kpi.formulaHelp"), apply: t("datox.kpi.apply"),
    preview: t("datox.kpi.preview"), unavailable: t("datox.kpi.unavailable"), explain: t("datox.kpi.explain"),
    sourceRows: t("datox.kpi.sourceRows"), sourceDataset: t("datox.kpi.sourceDataset"), sourceColumns: t("datox.kpi.sourceColumns"),
    sourceFilters: t("datox.kpi.sourceFilters"), sourceSort: t("datox.kpi.sourceSort"), sourceLimit: t("datox.kpi.sourceLimit"),
    sourceSubtitle: t("datox.kpi.sourceSubtitle"), sourceResult: t("datox.kpi.sourceResult"), sourceData: t("datox.kpi.sourceData"),
    sourceSelectedDataset: t("datox.kpi.sourceSelectedDataset"), sourceFields: t("datox.kpi.sourceFields"), sourceTechnical: t("datox.kpi.sourceTechnical"),
    sourceConstraints: t("datox.kpi.sourceConstraints"), sourceNoConstraints: t("datox.kpi.sourceNoConstraints"), sourceEvidence: t("datox.kpi.sourceEvidence"),
    sourceEvidenceHelp: t("datox.kpi.sourceEvidenceHelp"), sourceAllColumns: t("datox.kpi.sourceAllColumns"), sourceRelevantColumns: t("datox.kpi.sourceRelevantColumns"),
    sourceNoRows: t("datox.kpi.sourceNoRows"), sourceClose: t("datox.kpi.sourceClose"), sourceRetry: t("datox.kpi.sourceRetry"),
    exportPreparing: t("datox.kpi.exportPreparing"), exportTimeout: t("datox.kpi.exportTimeout"), exportFailed: t("datox.kpi.exportFailed"),
    errors: Object.fromEntries(["expression_required", "expression_too_long", "too_complex", "unknown_column", "numeric_column_required", "unsupported_function", "aggregate_arguments", "function_arguments", "aggregate_required", "round_digits", "invalid_expression", "invalid_calculation", "widget_id_required", "unsupported_expression", "duplicate_widget_id", "formula_widget_type", "ambiguous_column"].map((code) => [code, t(`datox.kpi.${code}` as keyof typeof KPI_ENGLISH)])),
  }
}
